import { UserCredentials } from "../models/User";
import client from "./axios";

interface LoginResponse {
  token: string;
  refreshToken: string;
}

const authUrl = `${window.__env.BASE_URL}/auth`;

export const Authentication = {
  login: (user: UserCredentials) => client.post<LoginResponse>(`${authUrl}/login`, user),
  logout: (refreshToken: string) => client.post(`${authUrl}/logout`, { refreshToken }),
  token: (refreshToken: string) => client.post<LoginResponse>(`${authUrl}/token`, { refreshToken }),
}